// extracted by mini-css-extract-plugin
module.exports = {"questions__head":"question_questions__head___xs0D","questions__body-answer":"question_questions__body-answer__146jE","question_open":"question_question_open__33LMn"};